/* globals scriptVariables */

import {Loader, LoaderOptions} from 'google-maps';
import loadGoogleMapsApi from 'load-google-maps-api';
// import MarkerClusterer from '@google/markerclustererplus';
import Chartist from 'chartist';
import _ from 'lodash';
import MarkerClusterer from '@google/markerclustererplus';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import Cookies from 'js-cookie';

// import MarkerWithLabel from '@google/markerwithlabel';

export default class LocationViewer {
	/**
	 * Creates a map with multiple levels of clusterers and map markers.
	 * @param {string|HTMLElement} element The container to hold the map when it loads.
	 */
	constructor(element){
		this.wrapper = typeof(element) === 'string' ? document.querySelector(element) : element;
		if(this.wrapper) {
			this.tabs 	 = this.wrapper.querySelector('.tabs');
			this.mapEle  = this.wrapper.querySelector('.cluster-map');
			
			// console.log("API Key: ", wordpress_globals.google_maps_api_key);

			//if tabs, may need deleting
			if(this.tabs === null){
				throw new Error('Tabs element cannot be found.');
			}

			//if map
			if(this.mapEle === null){
				throw new Error('Map element cannot be found.');
			}

			//if markers dataset
			if(typeof this.wrapper.dataset.markers === 'undefined'){
				throw new Error('Markers data attribute is empty');
			}


			//parsing the marker data to JSON
			this.markersJSON = JSON.parse(this.wrapper.dataset.markers);
			// console.log("Markers JSON: \n", this.markersJSON);
			
			this.markersArr = [];
			this.clustersArr = [];
			this.cluster_overlays = [];
			this.chart_data = [];
			this.charts = [];
			this.openedMarker = undefined;
			this.to_ignore = [];
			//how many times the map has been idle.
			this.actions = 0;

			this.region_level = 9;
			this.la_level = 12;
			this.la_zoom_level = 12;


			/**
			 * Markers for a given LA
			 */
			this.la_markers = {};

			/**
			 * Data for the LA Charts
			 */
			this.la_chart_data = [];

			/**
			 * Clusterers for a given LA
			 */
			this.la_clusters = [];

			/**
			 * Overlays for a given LA (circle with chart)
			 */
			this.la_overlays = [];

			/**
			 * Markers for the regions
			 */
			this.region_markers = [];

			/**
			 * Charts generated for a given LA
			 */
			this.la_charts = [];

			/**
			 * All markers present on Google maps.
			 */
			this.all_markers = [];

			/**
			 * All Clusters present on Google Maps.
			 */
			this.all_clusters = [];

			/**
			 * The dropdown option that has been selected e.g. outstandiong, good etc.
			 */
			this.selected_result = undefined;

			/**
			 * The charts present on the page.
			 */
			this.charts = [];

			/**
			 * The region to display LA's for.
			 */
			this.display_region = undefined;

			/**
			 * The LA to display schools for
			 */
			this.display_la = undefined;

			/**
			 * the currently opened window.
			 */
			this.displayed_infowinow = undefined;

			this.foundMarker = null;

			this.defaultClusterObj = {
				anchorIcon: [86, 30],
				anchorText: [50, 24],
				width: 60,
				height: 86,
				fontFamily: "'fsalbert', sans-serif",
				fontWeight: 'bold',
				textSize: 16,
				textColor: 'white'
			};

			loadGoogleMapsApi({key: wordpress_globals.google_maps_api_key }).then(mapsApi => {
				this.api = mapsApi;
				this.infowindow = new mapsApi.InfoWindow({
					content: 'dsfdsfdsfs',
					// pixelOffset: new mapsApi.Size(-280, 66),
					// maxWidth: 400
					closeBoxURL: ''
				});
				// console.log("Info window: ", this.infowindow);
				this.initMap();
			});

			document.addEventListener('click', (e) => {
				var container = $("#map-popover");
				let is_not_container = !container.is(e.target);
				let has_no_container = container.has(e.target).length === 0;
	


				// if the target of the click isn't the container nor a descendant of the container
				if (is_not_container && has_no_container && this.displayed_infowinow) {
					if(document.getElementById('map-popover') && e.target.tagName !== "IMG") {
						this.displayed_infowinow.close();
					}
				}
			});

		}
	}

	initMap(){
		let lat, lng, zoom, bounds;
		if(window.outerWidth <= 1000) {
			lat = 52.950001;
			lng = -1.772232;

			// lat = 52.950001
			// lng = -3.940536;

			zoom = 6;
			bounds = {
				east: 7.3,
				north: 61.740016,
				west: -14.004012,
				south: 49.072082
			}
		} else {
			lat = 52.950001
			lng = -3.940536;
			zoom = 6.8;

			bounds = {
				east: 7.3,
				north: 61.740016,
				west: -14.004012,
				south: 50.072082
			}
		}

		//south 50.152597 x -1.250174
		//north 58.940093 x -1.250174
		//west 53.655610 x -10.706117
		//east 53.655610 x 2.592259

		this.map = new this.api.Map(this.mapEle, {
			center: {lat: parseFloat(lat), lng: parseFloat(lng)},
			zoom: zoom,
			mapTypeControl: false,
			streetViewControl: false,
			restriction: {
				latLngBounds: bounds,
				strictBounds: true
			},
			styles: 
			[
				{
					"featureType": "all",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"saturation": 36
						},
						{
							"color": "#6f7281"
						},
						{
							"lightness": 40
						}
					]
				},
				{
					"featureType": "all",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#ffffff"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"featureType": "all",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#8392e4"
						},
						{
							"lightness": 20
						},
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#ccd4ec"
						},
						{
							"lightness": 17
						},
						{
							"weight": 1.2
						},
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "administrative.country",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "administrative.country",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "administrative.country",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "administrative.province",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "administrative.province",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "administrative.locality",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "administrative.locality",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "administrative.neighborhood",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "administrative.neighborhood",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "administrative.land_parcel",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "administrative.land_parcel",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#c4caea"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "landscape.man_made",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#dce2ed"
						}
					]
				},
				{
					"featureType": "landscape.natural",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e4eaf5"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#c3c8dc"
						},
						{
							"lightness": 21
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#d8dfed"
						},
						{
							"lightness": 21
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#eeeff5"
						},
						{
							"lightness": 17
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#eeeff5"
						},
						{
							"lightness": 29
						},
						{
							"weight": 0.2
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeff5"
						},
						{
							"lightness": 18
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeff5"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeff5"
						},
						{
							"lightness": 19
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "transit.line",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "transit.line",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "transit.station",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "transit.station.rail",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#d2d5e1"
						},
						{
							"lightness": 17
						}
					]
				}
			]
		});

		this.create_region_clusters();
		if(this.foundMarker) {
			this.display_la = this.foundMarker.la;
            const y = this.wrapper.getBoundingClientRect().top + window.pageYOffset + -150;
            window.scrollTo({top: y, behavior: 'smooth'});
			this.toggle_region(false);
			this.toggle_la(false);
			this.toggle_school(true);
			this.map.setZoom(this.la_zoom_level);
			this.map.panTo(this.foundMarker.getPosition());
			google.maps.event.trigger(this.foundMarker, 'click');
			console.log("locations.js - Found AP ", this.foundMarker);

			Cookies.remove('searchTerm');
			Cookies.remove('searchPostType');
			Cookies.remove('searchId');
		}
		// this.createClusters();

		/** When map is zoomed see if we should hide markers */
		google.maps.event.addListener(this.map, 'zoom_changed', () => {
			let zoom = this.map.getZoom();
			console.log("Zoom: " + zoom);
			this.infowindow.close();
			if(this.displayed_infowinow) { this.displayed_infowinow.close() }

			if(zoom < this.region_level) {
				this.display_region = undefined;
				this.display_la = undefined;
				this.toggle_region(true);
				this.toggle_la(false);
				this.toggle_school(false);
			}
			else if(zoom >= this.region_level && zoom < this.la_level) {
				this.display_la = undefined;
				this.toggle_region(false);
				this.toggle_la(true);
				this.toggle_school(false);
			} else {
				this.toggle_region(false);
				this.toggle_la(false);
				this.toggle_school(true);
			}
		})		
	}

	toggle_region(visible = true) {
		Object.keys(this.markersJSON).forEach((key, index) => {
			let region_id = key.split(' ').join('_') + "_chart";
			let region_element = document.getElementById(region_id);
			if(region_element) {
				let region_holder = region_element.parentElement
				console.log("Key: " + key);
				// region_element.getElementById('')
				if(visible === true) {
					let pupil_count = region_holder.querySelector('h4').innerHTML;
					//if we have no pupils in a certain region, then hide it, else show as normal.
					if(pupil_count != "0") {
						region_holder.classList.remove('htmlMarker--invisible');
						console.log("Pupil count: " + pupil_count + " showing");
					} else {
						region_holder.classList.add('htmlMarker--invisible');
						console.log("Pupil count: " + pupil_count + " hiding");
					}
				} else {
					region_holder.classList.add('htmlMarker--invisible');
				}
			}
		})
	}

	toggle_la(visible = true) {
		/**Toggling visiblitiy of LA depending on pre-determined zoom level.*/
		let la = (search = undefined) => {
			Object.keys(this.la_markers).forEach((key, index) => {
				// console.log(key);
				let la = this.la_markers[key];
				// let la_marker = la.marker;
				let la_children = la.children;
				let la_parent = la.parent;

				let la_element = document.getElementById(key + "_chart");
				
				if(la_element) {
					let la_holder = la_element.parentElement;
					let rating_count = 0;
					if(visible === true) {
						/** If a parent is set. */
						if(search) {
							//only showing if the parent is what is currently selected
							if(search === la_parent) {
								//if the user has selected an Ofsted inspection to filter by.
								if(this.selected_result) {
										/**Going through each of the schools and ensuring LA's with no
										 * schools with the selected inspection are hidden.
										 */
										la_children.forEach(school => {
											let icon = school.icon.url;
											// console.log(icon);
							
											//Using the icon e.g. outstanding.png to determine the value.
											if(icon.includes(this.selected_result.toLowerCase().replace(" ", "_"))) {
												rating_count++;
											}
										});

										//if we have found at least 1 school, ensure this is not invisble.
										if(rating_count > 0) {
											la_holder.classList.remove("htmlMarker--invisible");
										}
								} else {
									la_holder.classList.remove("htmlMarker--invisible");
								}
							}
						} else {
							//if the user has selected an Ofsted inspection to filter by.
							if(this.selected_result) {
									/**Going through each of the schools and ensuring LA's with no
									 * schools with the selected inspection are hidden.
									 */
									la_children.forEach(school => {
										let icon = school.icon.url;
										// console.log(icon);
						
										//Using the icon e.g. outstanding.png to determine the value.
										if(icon.includes(this.selected_result.toLowerCase().replace(" ", "_"))) {
											rating_count++;
										}
									});

									//if we have found at least 1 school, ensure this is not invisble.
									if(rating_count > 0) {
										la_holder.classList.remove("htmlMarker--invisible");
									}
							} else {
								la_holder.classList.remove("htmlMarker--invisible");
							}
							// la_holder.classList.remove("htmlMarker--invisible");
						}
					} else {
						la_holder.classList.add("htmlMarker--invisible");
					}
				}
			});
		}

		if(this.display_region) {
			la(this.display_region);
		} else {
			la();
		}
	}

	dropdown_selected(rating) {
		Object.keys(this.la_markers).forEach((key, index) => {
			console.log(this.la_markers[key]);
			let rating_count = 0;

			let la = this.la_markers[key];
			// let la_cluster = la.cluster;
			let children = la.children;

			let la_element = document.getElementById(key + "_chart");

			children.forEach(school => {
				let icon = school.icon.url;
				console.log(icon);

				if(icon.includes(rating.toLowerCase().replace(" ", "_"))) {
					rating_count++;
					school.setVisible(true);
				} else {
					school.setVisible(false);
				}
			});

			if(la_element) {
				let la_holder = la_element.parentElement;

				if(rating_count > 0) {
					la_holder.classList.remove("htmlMarker--invisible");
				} else {
					la_holder.classList.add("htmlMarker--invisible");
				}
			}
		})
	}

	toggle_school(visible = true) {
		Object.keys(this.la_markers).forEach((key, index) => {
			// console.log(key);
			let la = this.la_markers[key];
			// let la_marker = la.marker;
			let la_children = la.children;
			if(la_children.length > 0) {
				la_children.forEach(school => {
					// if(this.display_la) {
					let search = (this.display_la) ? this.display_la : '';
					if(visible === true && (search === '' || search === key)) {
						if(search === '') {
							if(this.selected_result) {	
								// school.setVisible(true);
								let icon = school.icon.url;
								console.log(icon);

								if(icon.includes(this.selected_result.toLowerCase().replace(" ", "_"))) {
									school.setVisible(true);
								} else {
									school.setVisible(false);
								}
							} else {
								school.setVisible(true);
							}
						}
						else if(this.selected_result) {
							let icon = school.icon.url;
							console.log(icon);

							if(icon.includes(this.selected_result.toLowerCase().replace(" ", "_"))) {
								school.setVisible(true);
							} else {
								school.setVisible(false);
							}
						} else {
							school.setVisible(visible);
						}
					} else {
						school.setVisible(false);	
					}
				});			
			}
			// if(la_element) {
			// 	let la_holder = la_element.parentElement;
			// 	if(visible === true) {
			// 		la_holder.classList.remove("htmlMarker--invisible");
			// 	} else {
			// 		la_holder.classList.add("htmlMarker--invisible");
			// 	}
			// }
		});
	}

	redraw_elements() {
		setTimeout(() => {
			let clusters = document.getElementsByClassName('cluster-0');
			if(clusters.length > 0) {
				for(let i = 0; i < clusters.length; i++) {
					let lea = clusters[i].classList[0];
					console.log("LEA: ", lea);
					let key = lea.split('_').join(' ');
					this.update_cluster(lea, key);
				}
			}
		}, 1000);
	}

	//wait for clusterers to display, then remove the node element *vintage NOT USED*.
	async waitForElementToDisplay(selector, time, max_time) {
		var timeout = null;
		var timer = null
		return new Promise(async resolve => {
			console.log("Searching for " + selector);

			if(this.to_ignore.length !== 0) {
				if(this.to_ignore.includes(selector)) {
					// console.log(selector + " is in to ignore");
					clearTimeout(timeout);
					clearInterval(timer);
					return resolve(undefined);
				}
			}
			timer = setInterval(function() {
				if(document.querySelector(selector)!=null) {
					// console.log(selector + " Found");
					clearTimeout(timeout);
					clearInterval(timer);
					return resolve(document.querySelector(selector));
				}
				console.log(selector + " Not found");
			}, time);

			//if after 10s we cannot find the item them it must not exist.
			timeout = setTimeout(() => {
				// console.log(selector + " doesn't exist, ignoring");
				clearInterval(timer);
				if(this.actions === 0) {
					this.to_ignore.push(selector);
				}
				return resolve(undefined);
			}, max_time)
		})
	}

	/**
	 * @typedef {Object} ChartData
	 * @property {number} total_count Total number of pupils for a given el
	 * @property {number} outstanding_count Total number of pupils from outstanding schools for a given el.
	 * @property {number} good_count Total number if puils from good schools for a given el.
	 * @property {number} requires_impovement_count Total number if puils from schools rated requires improvement for a given el.
	 * @property {number} inadequate_count Total number if puils from inadequate schools for a given el.
	 * @property {number} null_count Total number of pupils from schools without an Ofsted rating for a given el.
	 * @param {string} id ID you wish to use to identify where to place chart
	 * @param {function} onclick function you want to run when the overlay is clicked
	 * @param {bool} visible Whether to display the element initially.
	 * @param {ChartData} data Data you wish to fill chart with.
	 */

	/**
	 * Creates a custom HTML marker for a given Region/LA/School.
	 * 
	 * @param {number} lat Desired Latitude of HTML marker 
	 * @param {number} lng Desired Longtitude of HTML marker
	 * @param {string} content HTML content.
	 * @param {function} onclick Function to run when we click on the HTML element=
	 * @param {bool} visible Whether to display the marker or not?
	 * @param {string} key Name of LA/Region
	 * @param {string} type Type of marker (la or region)
	 * 
	 * @returns {OverlayViewSafe} HTML marker.
	 */
	create_HTML_marker(lat, lng, content, id, data, onclick, visible = true, key, type, outstanding_lat, outstanding_lng, good_lat, good_lng, requires_improvement_lat, requires_improvement_lng, inadequate_lat, inadequate_lng) {
		let that = this;
		function HTMLMarker(lat, lng) {
			this.lat = lat;
			this.lng = lng;
			this.setMap(that.map);
			this.pos = new google.maps.LatLng(lat,lng);
			this.inadequate_pos = new google.maps.LatLng(52.531, 1.702)
		}

		HTMLMarker.prototype = new google.maps.OverlayView();
		HTMLMarker.prototype.onRemove= function(){
			if (this.div) {
				this.div.parentNode.removeChild(this.div);
				this.div = null;
			}
		}

		//init your html element here
		HTMLMarker.prototype.onAdd= function(){
			var div = document.createElement('DIV');
			div.classList.add("htmlMarker");
			div.id = key.split(" ").join("-").toLowerCase();
			if(visible === false) {
				div.classList.add("htmlMarker--invisible");
			}
			div.style.position='absolute';
			div.innerHTML = content;
			var panes = this.getPanes();
			panes.overlayMouseTarget.appendChild(div);

			let this_el = panes.overlayMouseTarget.childNodes[panes.overlayMouseTarget.childNodes.length - 1];
			this_el.setAttribute("data-key", key)
			this_el.setAttribute("data-type", type)

			// let that = this;

			this_el.addEventListener("click", (e) => { 
				// console.log("Element has been clicked");
				let el = $(e.target).closest('.htmlMarker');
				let type = $(el).attr("data-type");
				let key = $(el).attr("data-key");

				//if region or la set, only display child markers with theis region/LA.
				if(type === "region") {
					that.display_region = key;
				}

				if(type === "la") {
					that.display_la = key
				}

				onclick();
			});
			this.div = div;
		}

		HTMLMarker.prototype.draw = function(){
			var overlayProjection = this.getProjection();
			// this.div.removeAttribute("style");
			var position;
			position = overlayProjection.fromLatLngToDivPixel(this.pos);
				
			this.div.style.left = position.x + 'px';
			this.div.style.top = position.y + 'px';
			var panes = this.getPanes();
		}


		HTMLMarker.prototype.setPosition = function(position, rating = "All", type = "region") {
			var point;
			if(rating !== "All" && type === "la") {
				// this.latlng_ = position;
				point = this.getProjection().fromLatLngToDivPixel(position);
			} else {
				point = this.getProjection().fromLatLngToDivPixel(this.pos);
			}
			if (point) {
			//   this.div.style.left = point.x + 'px';
			//   this.div.style.top = point.y + 'px';
				this.pos = position
			}
		  };

		let el = new HTMLMarker(lat, lng);
		// el.setVisible(visible);
		el.setMap(this.map);
		google.maps.event.addListener(el, 'click', function(event) {
			// google.maps.event.trigger(me, 'click');
			alert("Clicked a region");
		});

		$('#ofsted').change((event) => {
			console.log("Ofsted changed :)");
			// locations.ofsted_dropdown(event.target.value);
			let rating = event.target.value;

			// console.log();
			if(rating !== "All" && type === "la") {
				// el.onRemove();
				// el = undefined;
				// el = new HTMLMarker(52.531, 1.702);
				// el.onAdd();
				// el.draw();
				// this.la_markers[key].marker = el;
				// el.setMap(null);
				let latlng;

				if(rating === "Outstanding") {
					latlng = new google.maps.LatLng(outstanding_lat, outstanding_lng)
					// this.map.setCenter(new google.maps.LatLng(counts.outstanding_lat, counts.outstanding_lng));
				} else if(rating === "Good") {
					latlng = new google.maps.LatLng(good_lat, good_lng)
					// this.map.setCenter(new google.maps.LatLng(counts.good_lat, counts.good_lng));
				} else if(rating === "Inadequate" && !isNaN(inadequate_lat) && !isNaN(inadequate_lng)) {
					// latlng = new google.maps.LatLng(requires_improvement_lat, requires_improvement_lng)					// this.map.setCenter(new google.maps.LatLng(counts.inadequate_lat, counts.inadequate_lng));
					latlng = new google.maps.LatLng(inadequate_lat, inadequate_lng)					// this.map.setCenter(new google.maps.LatLng(counts.inadequate_lat, counts.inadequate_lng));
					// latlng = new google.maps.LatLng(52.531, 1.702)					// this.map.setCenter(new google.maps.LatLng(counts.inadequate_lat, counts.inadequate_lng));
					// this.map.setCenter(new google.maps.LatLng(52.531, 1.702));
				} else if(rating === "Requires Improvement") {
					latlng = new google.maps.LatLng(requires_improvement_lat, requires_improvement_lng)					// this.map.setCenter(new google.maps.LatLng(counts.inadequate_lat, counts.inadequate_lng));
					// latlng = new google.maps.LatLng(inadequate_lat, inadequate_lng)
					// this.map.setCenter(new google.maps.LatLng(counts.requires_improvement_lat, counts.requires_improvement_lng));
				}

				if(key === 'Suffolk') {
					console.log("lat: " + inadequate_lat + " lng: " + inadequate_lng);
				}

				el.setPosition(latlng, rating, type);
				// el.setMap(this.map);
				// this.map.invalidate();
				// el.
				// let overlayProjection = el.
				// let overlayProjection = el.getProjection();
				// var position = overlayProjection.fromLatLngToDivPixel(new google.maps.LatLng(52.531, 1.702));
				// var panes = el.getPanes();
				// console.log(el.div);
				// el.div.style.left = position.x + 'px';
				// el.div.style.top = position.y + 'px';
				// el.setPosition(new google.maps.LatLng(52.531, 1.702))
				// let top = 52.531;
				// let left = 1.702;
				// el.div()
			} else {
				if(rating === "All") {
					el.setPosition(new google.maps.LatLng(lat, lng), rating, type);
				}
			}
		});

		this.create_chart(id, data);
		return el;
	}

	/**
	 * Create a pie chart for a given region/LA/school.
	 * 
	 * @param {string} id ID you wish to use to identify where to place chart
	 * @param {ChartData} data Data you wish to fill chart with.
	 * 
	 * @returns {string} The HTML element for the chart.
	 */
	create_chart(id, data) {
		/**When Google maps has done loading, add the chart to the previously created HTML marker. */
		google.maps.event.addListenerOnce(this.map, 'idle', ()=> {	
			let chart_el = document.getElementById(id);
			let the_data = [
				{
					value: data.outstanding_count,
					name: "Outstanding",
					meta: 'Outstanding count',
					className: "map-marker--green"
				}, 
				{
					value: data.good_count,
					name: "Good",
					meta: "Good count",
					className: "map-marker--yellow"
				},
				{
					value: data.requires_impovement_count,
					name: "Requires Improvement",
					meta: "Requires improvement count",
					className: "map-marker--orange"
				},
				{
					value: data.inadequate_count,
					name: "Inadequate",
					meta: 'Inadequate count',
					className: "map-marker--pink"
				},
				{
					value: data.null_count,
					name: "Null",
					meta: 'Null count',
					className: "map-marker--grey"
				}
			]

			var chart_data = {
				series: the_data
			};
			
			// As options we currently only set a static size of 300x200 px
			var options = {
				// donut: true,
				width: '90px',
				height: '90px'
			};
			
			// In the global name space Chartist we call the Line function to initialize a line chart. As a first parameter we pass in a selector where we would like to get our chart created. Second parameter is the actual data object and as a third parameter we pass in our options
			let pie = new Chartist.Pie(chart_el, chart_data, options);
			this.charts[id] = pie;
			//setting the original data to be the data first set here as it may be changed later down the line.
			this.charts[id].original_data = the_data;
		});
	}

	create_region_clusters() {
		Object.keys(this.markersJSON).forEach((key, index) => {
			let region = this.markersJSON[key];
			let region_name = key.split(' ').join('_')
			console.log("Creating Clusterer for " + key);

			//creating a cluster for the LEA's in a region
			let counts = this.create_la_clusters(region, key)
			console.log(counts);

			/**Styles for clusterer */
			var styles = [{
				fontFamily:"gilroy",
				fontWeight:"700",
				textColor:'#474F83', //navy
				textSize: 20,
				url: wordpress_globals.home_url + '/wp-content/themes/class/dist/images/icons/cluster.png',
				height: 80,
				width: 80,
				top: '50%',
				anchorText: [40, 0]
			}]

			/**Lat and lng from the Region post type. */
			let lat = parseFloat(region['lat']);
			let lng = parseFloat(region['lng']);

			/**Average lat of region. */
			let average_lat = counts.average_lat;
			/**Average lng of a region */
			let average_lng = counts.average_lng;

			var MarkerWithLabel = require('markerwithlabel')(google.maps);

			let url = wordpress_globals.home_url + '/wp-content/themes/class/dist/images/icons/outstanding.png';

			let region_id = region_name + "_chart";

			let content = `
				<div class = "map-marker-chart" id = "${region_id}"></div>

				<div class = "map-marker-content">
					<div>
						<h4>${counts.total_count}</h4>
					</div>
				</div>

				<div class = "map-marker-hover">
					<div class = "content">
						<p>Region: <strong>${key}</strong></p>
					</div>
					<div class = "arrow">
						<svg id="Layer_25" data-name="Layer 25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 39"><defs><style>.arrow-right{fill:#fff;}</style></defs><title>Pop-up Arrow Head</title><polygon class="arrow-right" points="27 19.5 0 0 0 39 27 19.5"/></svg>
					</div>
				</div>
			 `;

			let region_marker = this.create_HTML_marker(lat, lng, content, region_id, {
				total_count: counts.total_count,
				outstanding_count: counts.outstanding_count,
				good_count: counts.good_count,
				requires_impovement_count: counts.requires_impovement_count,
				inadequate_count: counts.inadequate_count,
				null_count: counts.null_count
			}, () => {
				console.log("Zooming and moving");
				this.map.setZoom(this.region_level);
				// this.display_region = key;
				let region = key;
				if(!this.selected_result) {
					this.map.setCenter(new google.maps.LatLng(average_lat, average_lng));
					// this.map.setCenter(new google.maps.LatLng(counts.average_lat, counts.average_lng));
				} else if(this.selected_result === "Outstanding") {
					this.map.setCenter(new google.maps.LatLng(counts.outstanding_lat, counts.outstanding_lng));
				} else if(this.selected_result === "Good") {
					this.map.setCenter(new google.maps.LatLng(counts.good_lat, counts.good_lng));
				} else if(this.selected_result === "Inadequate") {
					this.map.setCenter(new google.maps.LatLng(counts.inadequate_lat, counts.inadequate_lng));
					// this.map.setCenter(new google.maps.LatLng(52.531, 1.702));
				} else if(this.selected_result === "Requires Improvement") {
					this.map.setCenter(new google.maps.LatLng(counts.requires_improvement_lat, counts.requires_improvement_lng));
				} else {
					this.map.setCenter(new google.maps.LatLng(average_lat, average_lng));
					// this.map.setCenter(new google.maps.LatLng(counts.average_lat, counts.average_lng));
				}
				// this.map.setCenter(new google.maps.LatLng(average_lat, average_lng));
			}, true, key, "region");

		})
	}

	/**
	 * @typedef {Object} Pupils
	 * @property {number} total_count Total number of pupils for a given region
	 * @property {number} outstanding_count Total number of pupils from outstanding schools in a given area
	 * @property {number} good_count Total number if puils from good schools in the given region
	 * @property {number} requires_impovement_count Total number if puils from schools rated requires improvement in the given region
	 * @property {number} inadequate_count Total number if puils from inadequate schools in the given region
	 * @property {number} null_count Total number of pupils from schools without an Ofsted rating in a given region
	 * @property {number} average_lat Average latitude for a given region
	 * @property {number} average_lng Average Longtitude for a given reggion
	 * @property {Array} marker_array All markers for a given region.
	 */

	/**
	 * Create a cluster for all the LA's in a given region
	 * @param {Array} region The region to create the cluster for.
	 * @param {string} region_name The name of the region this LA belongs to.
	 * @param {string} [rating=undefined] The rating to filter by, leaving blank indicates no filter.
	 * @returns {Pupils} Pupil count for an area for each Ofsted rating. 
	 */
	create_la_clusters(region, region_name, rating = undefined) {
		/** total counts for the region */
		var region_total_pupil_count = 0;
		var region_outstanding_count = 0;
		var region_good_count = 0;
		var region_requires_improvement_count = 0;
		var region_inadequate_count = 0;
		var region_null_count = 0;

		/** All he markers for a given region. */
		var total_marker_array = [];

		/**The average lat and lng for a given region. */
		var average_lat = 0;
		var average_lng = 0;
		var average_outstanding_lat = 0;
		var average_outstanding_lng = 0;
		var outstanding_count_la = 0;
		var average_good_lat = 0;
		var average_good_lng = 0;
		var good_count_la = 0;
		var average_requires_improvement_lat = 0;
		var average_requires_improvement_lng = 0;
		var requires_improvement_count_la = 0;
		var average_inadequate_lat = 0;
		var average_inadequate_lng = 0;
		var inadequate_count_la = 0;
		var count = 0;

		//NOTE: they want a count for those without a count.
		Object.keys(region).forEach((key, index) => {
			//ensuring we don;t perform operations on lat lng and only an LEA.
			if(key !== 'lat' && key !== 'lng') {
				count++;
				let la = region[key];
				/**Removing spaces from the name for CSS compatibility*/
				let la_name = key.split(' ').join('_')
				// console.log("Creating clusterer for " + key);

				let marker_obj = this.createMarkers(la, rating);
				let marker_array = marker_obj.markers;

				/**Adding to the average lat and lng for a given region */
				average_lat += marker_obj.average_lat;
				average_lng += marker_obj.average_lng;
				if(!isNaN(marker_obj.outstanding_lat)) {
					average_outstanding_lat += parseFloat(marker_obj.outstanding_lat);
				}

				if(!isNaN(marker_obj.outstanding_lng))
					average_outstanding_lng += parseFloat(marker_obj.outstanding_lng);

				if(!isNaN(marker_obj.good_lat))
					average_good_lat += parseFloat(marker_obj.good_lat);
					
				if(!isNaN(marker_obj.good_lng))	
					average_good_lng += parseFloat(marker_obj.good_lng);
				
				if(!isNaN(marker_obj.requires_improvement_lat))
					average_requires_improvement_lat += parseFloat(marker_obj.requires_improvement_lat);

				if(!isNaN(marker_obj.requires_improvement_lng))
					average_requires_improvement_lng += parseFloat(marker_obj.requires_improvement_lng);

				if(!isNaN(marker_obj.inadequate_lat))
					average_inadequate_lat += parseFloat(marker_obj.inadequate_lat);

				if(!isNaN(marker_obj.inadequate_lng))
					average_inadequate_lng += parseFloat(marker_obj.inadequate_lng);

				total_marker_array = total_marker_array.concat(marker_array)
				this.all_markers = this.all_markers.concat(marker_array);
				//adding the markers for the current LA to the list.
				// this.la_markers[la_name] = marker_array;

				/**Counts for each LA */
				var total_pupil_count = 0;
				var outstanding_count = 0;
				var good_count = 0;
				var requires_impovement_count = 0;
				var inadequate_count = 0;
				let null_count = 0;				

				let contains_outstading = false;
				let contains_good = false;
				let contains_requires_improvement = false;
				let contains_inadequate = false;

				//for each school in the LA,
				la.forEach(school => {
					let pupil_count = parseInt(school.pupil_number);
					let rating = school.rating;

					if(!isNaN(pupil_count)) {
						total_pupil_count += pupil_count

						//adding pupil count to the schools rating.
						if(rating === "Outstanding") {
							outstanding_count += pupil_count;
						} else if (rating === "Good") {
							good_count += pupil_count;
						} else if (rating === "Requires Improvement") {
							requires_impovement_count += pupil_count
						} else if(rating === "Inadequate") {
							inadequate_count += pupil_count
						} else {
							null_count += pupil_count
						}
					}

					if(rating === "Outstanding") {
						// outstanding_count_la++;
						contains_outstading = true;
					} else if (rating === "Good") {
						contains_good = true;
						// good_count_la++;
					} else if (rating === "Requires Improvement") {
						// requires_improvement_count_la++;
						contains_requires_improvement = true;
					} else if(rating === "Inadequate") {
						// inadequate_count_la++;
						contains_inadequate = true;
					}
				});

				if(contains_outstading) {
					outstanding_count_la++;	
				}

				if(contains_good) {
					good_count_la++;
				}

				if(contains_requires_improvement) {
					requires_improvement_count_la++;
				}

				if(contains_inadequate) {
					inadequate_count_la++;
				}

				//  /**Creating the chart for the given LA. */

				let la_id = la_name + "_chart";

				let content = `
					<div class = "map-marker-chart" id = "${la_id}"></div>

					<div class = "map-marker-content">
						<h4>${total_pupil_count}</h4>
					</div>

					<div class = "map-marker-hover">
						<div class = "content">
							<p>LA: <strong>${key}</strong></p>
						</div>
						<div class = "arrow">
							<svg id="Layer_25" data-name="Layer 25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 39"><defs><style>.arrow-right{fill:#fff;}</style></defs><title>Pop-up Arrow Head</title><polygon class="arrow-right" points="27 19.5 0 0 0 39 27 19.5"/></svg>
						</div>
					</div>
				`;

				//if we are Outstanding, set the lat to the average lat for outstanding, else good, etc.
				//if not just set to the average of all markers.
				// let average_lat = marker_obj.average_lat;
				// let average_lng = marker_obj.average_lng;

				// if() {
				// 	if(!this.selected_result) {
				// 		this.map.setCenter(new google.maps.LatLng(marker_obj.average_lat, marker_obj.average_lng));
				// 	} else if(this.selected_result === "Outstanding") {
				// 		this.map.setCenter(new google.maps.LatLng(marker_obj.outstanding_lat, marker_obj.outstanding_lng));
				// 	} else if(this.selected_result === "Good") {
				// 		this.map.setCenter(new google.maps.LatLng(marker_obj.good_lat, marker_obj.good_lng));
				// 	} else if(this.selected_result === "Inadequate") {
				// 		this.map.setCenter(new google.maps.LatLng(marker_obj.inadequate_lat, marker_obj.inadequate_lng));
				// 	} else if(this.selected_result === "Requires Improvement") {
				// 		this.map.setCenter(new google.maps.LatLng(marker_obj.requires_improvement_lat, marker_obj.requires_improvement_lng));
				// 	} else {
				// 		this.map.setCenter(new google.maps.LatLng(marker_obj.average_lat, marker_obj.average_lng));
				// 	}
				// }

				let cluster_marker = this.create_HTML_marker(marker_obj.average_lat, marker_obj.average_lng, content, la_id, {
					total_count: total_pupil_count,
					outstanding_count: outstanding_count,
					good_count: good_count,
					requires_impovement_count: requires_impovement_count,
					inadequate_count: inadequate_count,
					null_count: null_count
				}, () => {
					this.map.setZoom(this.la_zoom_level);
					if(!this.selected_result) {
						this.map.setCenter(new google.maps.LatLng(marker_obj.average_lat, marker_obj.average_lng));
					} else if(this.selected_result === "Outstanding") {
						this.map.setCenter(new google.maps.LatLng(marker_obj.outstanding_lat, marker_obj.outstanding_lng));
					} else if(this.selected_result === "Good") {
						this.map.setCenter(new google.maps.LatLng(marker_obj.good_lat, marker_obj.good_lng));
					} else if(this.selected_result === "Inadequate") {
						this.map.setCenter(new google.maps.LatLng(marker_obj.inadequate_lat, marker_obj.inadequate_lng));
					} else if(this.selected_result === "Requires Improvement") {
						this.map.setCenter(new google.maps.LatLng(marker_obj.requires_improvement_lat, marker_obj.requires_improvement_lng));
					} else {
						this.map.setCenter(new google.maps.LatLng(marker_obj.average_lat, marker_obj.average_lng));
					}
				}, false, la_name, "la", marker_obj.outstanding_lat, marker_obj.outstanding_lng, marker_obj.good_lat, marker_obj.good_lng,
				marker_obj.requires_improvement_lat, marker_obj.requires_improvement_lng, 
				marker_obj.inadequate_lat, marker_obj.inadequate_lng);

				this.la_markers[la_name] = {
					cluster: cluster_marker,
					children: marker_array,
					parent: region_name
				};

				/** Adding total counts of an LEA to the region */
				region_total_pupil_count += total_pupil_count;
				region_outstanding_count += outstanding_count;
				region_good_count += good_count;
				region_requires_improvement_count += requires_impovement_count;
				region_inadequate_count += inadequate_count;
				region_null_count += null_count;
			}
		})

		//finalising average
		average_lat = average_lat / count;
		average_lng = average_lng / count;
		
		if(outstanding_count_la !== 0 && average_outstanding_lat !== 0 && average_outstanding_lng !== 0) {
			average_outstanding_lat = average_outstanding_lat / outstanding_count_la;
			average_outstanding_lng = average_outstanding_lng / outstanding_count_la;
		} else {
			average_outstanding_lat = average_lat;
			average_outstanding_lng = average_lng;
		}

		if(good_count_la !== 0 && average_good_lat !== 0 && average_good_lng !== 0) {
			average_good_lat = average_good_lat / good_count_la;
			average_good_lng = average_good_lng / good_count_la;
		} else {
			average_good_lat = average_lat;
			average_good_lng = average_lng
		}

		if(requires_improvement_count_la !== 0 && average_requires_improvement_lat !== 0 && average_requires_improvement_lng !== 0) {
			average_requires_improvement_lat = average_requires_improvement_lat / requires_improvement_count_la;
			average_requires_improvement_lng = average_requires_improvement_lng / requires_improvement_count_la;
		} else {
			average_requires_improvement_lat = average_lat;
			average_requires_improvement_lng = average_lng;
		}

		if(inadequate_count_la !== 0 && average_inadequate_lat !== 0 && average_inadequate_lng !== 0) {
			average_inadequate_lat = average_inadequate_lat / inadequate_count_la;
			average_inadequate_lng = average_inadequate_lng / inadequate_count_la;
		} else {
			average_inadequate_lat = average_lat;
			average_inadequate_lng = average_lng;
		}

		return {
			total_count: region_total_pupil_count,
			outstanding_count: region_outstanding_count,
			good_count: region_good_count,
			requires_impovement_count: region_requires_improvement_count,
			inadequate_count: region_inadequate_count,
			null_count: region_null_count,
			average_lat: average_lat,
			average_lng: average_lng,
			marker_array: total_marker_array,
			outstanding_lat: average_outstanding_lat,
			outstanding_lng: average_outstanding_lng,
			good_lat: average_good_lat,
			good_lng: average_good_lng,
			requires_improvement_lat: average_requires_improvement_lat,
			requires_improvement_lng: average_requires_improvement_lng,
			inadequate_lat: average_inadequate_lat,
			inadequate_lng: average_inadequate_lng
		};
	}

	/**
	 * Takes in an LEA / Region and updates the given ID's element with the chart saved earlier.
	 * @param {string} id ID / class of the element to place chart in.
	 * @param {*} key LEA / Region to get the data for
	 */
	update_cluster(id, key) {
		//LEAs can have multiple clusters so must be class.
		let cluster = document.getElementsByClassName(id);
		if(cluster.length > 0) {
			let chart = this.charts[key];

			if(chart) {

				if(_.isElement(chart.chart)) {
					//if we have any svgs then the pie is loaded.
					if(chart.chart.getElementsByTagName("svg").length > 0) {
						this.charts[key].chart = this.charts[key].chart.outerHTML;
						for(let i = 0; i < cluster.length; i++) {
							cluster[i].innerHTML = this.charts[key].chart + this.charts[key].pupils;
						}
					}
				} else {
					for(let i = 0; i < cluster.length; i++) {
						cluster[i].innerHTML = this.charts[key].chart + this.charts[key].pupils
					}
				}
			}
		}
	}

	create_charts(id, key, pupils) {
		// let chart = document.getElementById(id + "-chart");
		let chart_holder = document.createElement("DIV");
		chart_holder.classList.add('map-marker-chart');
		chart_holder.id = id + "-chart";
		document.body.appendChild(chart_holder);

		let data = this.chart_data[key];

		if(chart_holder) {
			// Create a simple line chart
			var chart_data = {
				series: data
			};
			
			// As options we currently only set a static size of 300x200 px
			var options = {
				// donut: true,
				width: '90px',
				height: '90px'
			};
			
			// In the global name space Chartist we call the Line function to initialize a line chart. As a first parameter we pass in a selector where we would like to get our chart created. Second parameter is the actual data object and as a third parameter we pass in our options
			let pie = new Chartist.Pie(chart_holder, chart_data, options);
			this.charts[id] = pie;
			this.charts[id].original_data = data;
		}


		return {
			chart: document.getElementById(id + "-chart"),
			pupils: `<div class = "map-marker-content"><h4>${pupils}</h4></div>`
		}
	}

	draw_overlays() {
		Object.keys(this.markersJSON).forEach((key, index) => {
			// console.log("Cluster: ", this.clustersArr[key].options);
			let cluster_marker = document.getElementsByClassName(key)[0];
			if(cluster_marker) {
				let key_no_spaces = key.split(' ').join('_')
				let chart = document.getElementById(key_no_spaces + "-chart")
				if(!chart) {
					// console.log("Chart data: ", this.chart_data[key])
					this.load_overlay(cluster_marker, this.cluster_overlays[key], this.chart_data[key], '#' + key_no_spaces + "-chart")
				}
			}
			// let cluster_marker = document.getElementsByClassName(key)[0];
			// cluster_marker.innerHTML = this.cluster_overlays[key];
			// cluster_marker.
			// cluster_marker.innerHTML = "TEST!";
		});
	}

	load_overlay(el, overlay, data, id) {
		el.innerHTML = overlay;
		// Create a simple line chart
		var chart_data = {
			series: data
		};
		
		// As options we currently only set a static size of 300x200 px
		var options = {
			// donut: true,
			width: '90px',
			height: '90px'
		};
		
		// In the global name space Chartist we call the Line function to initialize a line chart. As a first parameter we pass in a selector where we would like to get our chart created. Second parameter is the actual data object and as a third parameter we pass in our options
		new Chartist.Pie(id, chart_data, options);
		// new Chartist.Pie(id, data);
	}

	/**
	 * @typedef {Object} School_markers
	 * @property {Array} markers Array of google maps markers which we want to display.
	 * @property {number} average_lat The average latitude generated for a given LA.
	 * @property {number} average_lng The average longtitude for a given LA
	 */
	
	/**
	 * Function that converts an array of schools into an array of Google Maps markers.
	 * 
	 * @param {Array} schoolArr Schools from a given LEA that will be converting into Google maps markers.
	 * @param {String} rating A rating to filter the schools by e.g. Outstanding should only display outstanding schools.
	 * 
	 * @returns {School_markers} The array of markers as well as the average lat and lng for a sspecified LA.
	 */
	createMarkers(schoolArr, rating){

		var average_lat = 0;
		var average_lng = 0;

		//average lng and lat for all the different ratings.
		var average_outstanding_lat = 0;
		var average_outstanding_lng = 0;
		var outstanding_count = 0;
		var average_good_lat = 0;
		var average_good_lng = 0;
		var good_count = 0;
		var average_requires_improvement_lat = 0;
		var average_requires_improvement_lng = 0;
		var requires_imporvement_count = 0;
		var average_inadequate_lat = 0;
		var average_inadequate_lng = 0;
		var inadequate_count = 0;

		let count = schoolArr.length;

		let markerArr = schoolArr.map((school, i) => {

			//adding the lat and lng to the average for calculation at end.
			let lat = parseFloat(school.locations.lat);
			let lng = parseFloat(school.locations.lng);
			average_lat += lat;
			average_lng += lng;

			if(school.rating === "Outstanding") {
				average_outstanding_lat += parseFloat(school.locations.lat);
				average_outstanding_lng += parseFloat(school.locations.lng);
				outstanding_count++;
			}

			if(school.rating === "Good") {
				average_good_lat += parseFloat(school.locations.lat);
				average_good_lng += parseFloat(school.locations.lng);
				good_count++;
			}

			if(school.rating === "Requires Improvement") {
				average_requires_improvement_lat += parseFloat(school.locations.lat);
				average_requires_improvement_lng += parseFloat(school.locations.lng);
				requires_imporvement_count++;
			}

			if(school.rating === "Inadequate") {
				average_inadequate_lat += parseFloat(school.locations.lat);
				average_inadequate_lng += parseFloat(school.locations.lng);
				inadequate_count++;
			}

			if(!rating) {
				var marker = this.create_marker(school)
			} else {
				
				//if the school has the selected rating then display it.
				if(school.rating === rating || rating == "All") {
					// console.log("school is: ", school.rating);
					var marker = this.create_marker(school);
				}
			}

		if(marker) {
			if(Cookies.get('searchPostType') === 'schools') {
				let id = Cookies.get('searchId');
				if(id == school.id) {
					this.foundMarker = marker;
					console.log("schoolarr: ", schoolArr);
				}
			}
			// console.log("Created marker: ", marker.getPosition().lat());
			return marker;
		}
	});

	//Finalysing average lat and lng.
	average_lat = average_lat / count;
	average_lng = average_lng / count;

	average_outstanding_lat = average_outstanding_lat / outstanding_count;
	average_outstanding_lng = average_outstanding_lng / outstanding_count;

	average_good_lat = average_good_lat / good_count;
	average_good_lng = average_good_lng / good_count;

	average_requires_improvement_lat = average_requires_improvement_lat / requires_imporvement_count;
	average_requires_improvement_lng = average_requires_improvement_lng / requires_imporvement_count;

	average_inadequate_lat = average_inadequate_lat / inadequate_count;
	average_inadequate_lng = average_inadequate_lng / inadequate_count;

	if(Array.isArray(markerArr)) {
		var filtered = markerArr.filter(function (el) {
			// console.log("el: ", el);
			return el != undefined;
		});
		// console.log("Filtered: ", filtered);
		return {
			markers: filtered,
			average_lat: average_lat,
			average_lng: average_lng,
			outstanding_lat: average_outstanding_lat,
			outstanding_lng: average_outstanding_lng,
			good_lat: average_good_lat,
			good_lng: average_good_lng,
			requires_improvement_lat: average_requires_improvement_lat,
			requires_improvement_lng: average_requires_improvement_lng,
			inadequate_lat: average_inadequate_lat,
			inadequate_lng: average_inadequate_lng,
			outstanding_count: outstanding_count,
			good_count: good_count,
			requires_impovement_count: requires_imporvement_count,
			inadequate_count: inadequate_count

		};
	} else {
		return {
			markers: [markerArr],
			average_lat: average_lat,
			average_lng: average_lng,
			outstanding_lat: average_outstanding_lat,
			outstanding_lng: average_outstanding_lng,
			good_lat: average_good_lat,
			good_lng: average_good_lng,
			requires_improvement_lat: average_requires_improvement_lat,
			requires_improvement_lng: average_requires_improvement_lng,
			inadequate_lat: average_inadequate_lat,
			inadequate_lng: average_inadequate_lng
		};
	}
	}

	//Checking if the info window is open.
	isInfoWindowOpen(infoWindow){
		if(infoWindow) {
			var map = infoWindow.getMap();
			return (map !== null && typeof map !== "undefined");
		}

		return false;
	}

	create_marker(school) {
		var that = this;

		let location = school.locations;
		// console.log("School location: ", location);
		// console.log("lat: " + parseFloat(location.lat))
		// console.log("lng: " + parseFloat(location.lng))
		// console.log("Marker icon src: ", wordpress_globals.home_url + '/wp-content/themes/class/dist/images/icons/50.png');

		var MarkerWithLabel = require('markerwithlabel')(google.maps);

		let url = wordpress_globals.home_url + '/wp-content/themes/class/dist/images/icons/' + this.calculate_image(school.rating);
		// let url = this.calculate_image(school.rating);

		/** TODO: Get id I created here then click the marker. */

		let marker = new MarkerWithLabel({
			position: {lat: parseFloat(location.lat), lng: parseFloat(location.lng)},
			id: school.id,
			la: school.LEA,
			// labelContent: school.pupil_number
			labelContent: `<h4 data-id="${school.id}">` + school.pupil_number + "</h4>",
			labelAnchor: new google.maps.Point(0, 0),
			labelClass: "labels",
			icon: {
			    url 		: url,
			    size 		: new this.api.Size(80, 80),
			    scaledSize 	: new this.api.Size(80, 80), // smaller
			    origin 		: new this.api.Point(0, 0),
			    // anchor 		: new this.api.Point(30, 86)
			},
		})

		marker.setMap(this.map);
		marker.setVisible(false);

		//closing the info window that's open.
		$(document).mouseup(function(e) {
			var container = $(".map-popover-holder");

			// if the target of the click isn't the container nor a descendant of the container
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				// that.infowindow.close();
			}
		});

		marker.addListener('mouseover', function(e) {
			//If an opened info window is not already open.
			if(!document.getElementById('map-popover')) {
				// if(!that.isInfoWindowOpen(that.infowindow) || marker !== that.openedMarker) {
				console.log(e.target);
				// console.log(e.tb.currentTarget);
				let selected_element = e.ub.currentTarget;
				if(selected_element) {
					console.log('Selected Element: ', selected_element);
					// selected_element.style.backgroundColor = "blue";
					selected_element.style.opacity = 1;
					selected_element.style.backgroundColor = "translate";
					selected_element.style.overflow = "visible";
					var node = document.createElement("DIV");
					node.id = "marker-hover";
					node.classList.add('map-marker-hover', 'map-marker-hover--visible');
					node.innerHTML = `
					<div class = "content">
						<p><strong>${school.name}</strong></p>
					</div>
					<div class = "arrow">
						<svg id="Layer_25" data-name="Layer 25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 39"><defs><style>.arrow-right{fill:#fff;}</style></defs><title>Pop-up Arrow Head</title><polygon class="arrow-right" points="27 19.5 0 0 0 39 27 19.5"/></svg>
					</div>
					`;
					selected_element.appendChild(node);
					selected_element.firstElementChild.style.opacity = 0;
				}
				// e.target.style.backgroundColor = "blue";

				// that.openedMarker = undefined;
			}
			// }
		});

		marker.addListener('mouseout', function(e) {
			//If an opened info window is not already open.
			if(!document.getElementById('map-popover')) {
				//if a hover infowindow is open.
				let hover_dropdown = document.querySelector('#marker-hover');
				// if(hover_dropdown) {
				// 	that.infowindow.close();
				// }

				document.getElementById('marker-hover').remove();

				// that.openedMarker = undefined;
			}
		})


		google.maps.Map.prototype.panToWithOffset = function(latlng, offsetX, offsetY) {
			var map = this;
			var ov = new google.maps.OverlayView();
			ov.onAdd = function() {
				var proj = this.getProjection();
				var aPoint = proj.fromLatLngToContainerPixel(latlng);
				aPoint.x = aPoint.x+offsetX;
				aPoint.y = aPoint.y+offsetY;
				map.panTo(proj.fromContainerPixelToLatLng(aPoint));
			}; 
			ov.draw = function() {}; 
			ov.setMap(this); 
		};


		marker.addListener('click', async function(e) {
			//close any hover marker that may already be open.
			// if(document.getElementById('marker-hover')) {
			// 	// await that.infowindow.close();
			// }

			// that.infowindow.close();

			if(!that.isInfoWindowOpen(that.displayed_infowinow) || marker !== that.openedMarker) {
				that.openedMarker = marker;
				if(that.isInfoWindowOpen(that.displayed_infowinow)) {
					that.displayed_infowinow.close();
				}
				let hover = document.getElementById('marker-hover');
				if(hover) {
					hover.remove();
				}
				// console.log('info window: ', that.infowindow);

				let modal = document.getElementById('map-popover-modal');
				modal.style.display = "flex";

				/**
				 * Determines if string is URL
				 * @param {string} str String to determine if it is a URL.
				 * @returns {bool} If string is a URL.
				 */
				function validURL(str) {
					var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
					  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
					  '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
					  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
					  '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
					  '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
					return !!pattern.test(str);
				  }

				  let modal_content = `
					<div id = "map-popover-info-window" class = "map-popover">
						<div id = "map-popover-modal__close">
							<button id = "map-modal-close"></button>
						</div>
						<div class = "map-popover-modal__close"></div>
						<h4 class = "map-popover__title">${school.name}</h4>
						<p class = "map-popover__location grey">${school.address}</p>
						<p class = "map-popover__urn grey">URN: <strong class = "navy">${school.urn}</strong></p>
						<p class = "map-popover__lea grey">LA: <strong>${school.LEA}</strong></p>
						<p class = "map-popover__rating grey">Rating: <strong class = "${that.calculate_text_colour(school.rating)}">${school.rating}</strong></p>
						<p class = "map-popover__pupils grey">Number of pupils: <strong class = "navy">${school.pupil_number}</strong></p>
						<p class = "map-popover__key-stages grey">Age Range: <strong>${school.age_range}</strong></p>
				`

				if(validURL(school.ofsted_link) || validURL(school.website_link)) {
					modal_content += `<div class = "map-popover__buttons">`;
					if(validURL(school.ofsted_link)) {
						modal_content += `
							<a class = "btn navy" href = "${school.ofsted_link}" target = "_blank">
								<svg preserveAspectRatio="none" class = "empty" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195 45"><defs><style>.button-wiggle{fill:#424a81;}</style></defs><title>Button Wiggle</title><g id="Layer_23" data-name="Layer 23"><path class="button-wiggle" d="M114.73,2.5c11,0,22.16.17,34,.35,13.63.21,27.7.42,44.25.44v11.6l0,9,0,18.4c-15.64-1.56-34.12-1.77-48.68-1.77-7,0-14,.06-20.79.11-6.55.05-12.73.1-18.68.1-3.86,0-7.23,0-10.32-.06-4.42,0-8.75-.07-13.24-.07-13.75,0-25.89.21-38.75.43-12.6.23-25.61.45-40.53.47V2.85c12.09.53,23.87.78,36.89.78,14.62,0,29-.32,44.27-.66,5-.11,10.07-.23,15.33-.33S109,2.5,114.73,2.5h0m0-2c-5.4,0-10.79,0-16.28.14-21.49.43-40.23,1-59.56,1C26.47,1.63,13.8,1.4,0,.76v19.9c0,6.63,0,16.2,0,22.83,30.86,0,53.16-.9,81.28-.9,4.26,0,8.65,0,13.22.07q5,.06,10.34.06c12.25,0,25.86-.21,39.47-.21,17.92,0,35.85.36,50.68,2l0-20.63c0-6.87,0-15.7,0-22.58-32.36,0-56.33-.79-80.21-.79Z"/></g></svg>
								<svg preserveAspectRatio="none" class = "fill" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195 45"><defs><style>.button-wiggle-fill{fill:#424a81;}</style></defs><title>Button Wiggle Fill</title><g id="Layer_23" data-name="Layer 23"><path class="button-wiggle-fill" d="M195,44.5c-14.83-1.64-32.76-2-50.68-2-13.61,0-27.22.2-39.47.2-3.58,0-7,0-10.34-.06-4.57,0-9-.07-13.22-.07-28.12,0-50.42.91-81.28.91,0-6.63,0-16.2,0-22.83V.76c13.8.64,26.47.86,38.89.86,19.33,0,38.07-.55,59.56-1C103.94.54,109.33.5,114.73.5c23.89,0,47.85.79,80.21.79,0,6.87,0,15.71,0,22.58Z"/></g></svg>
								<span>Ofsted report</span>
							</a>
						`
						// modal_content += `<a href = "${school.ofsted_link}" target = "_blank"><button class = "btn btn--blue_inverse">Ofsted Report</button></a>`;
					}

					if(validURL(school.website_link)) {
						modal_content += `
							<a class = "btn navy" href = "${school.website_link}" target = "_blank">
								<svg preserveAspectRatio="none" class = "empty" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195 45"><defs><style>.button-wiggle{fill:#424a81;}</style></defs><title>Button Wiggle</title><g id="Layer_23" data-name="Layer 23"><path class="button-wiggle" d="M114.73,2.5c11,0,22.16.17,34,.35,13.63.21,27.7.42,44.25.44v11.6l0,9,0,18.4c-15.64-1.56-34.12-1.77-48.68-1.77-7,0-14,.06-20.79.11-6.55.05-12.73.1-18.68.1-3.86,0-7.23,0-10.32-.06-4.42,0-8.75-.07-13.24-.07-13.75,0-25.89.21-38.75.43-12.6.23-25.61.45-40.53.47V2.85c12.09.53,23.87.78,36.89.78,14.62,0,29-.32,44.27-.66,5-.11,10.07-.23,15.33-.33S109,2.5,114.73,2.5h0m0-2c-5.4,0-10.79,0-16.28.14-21.49.43-40.23,1-59.56,1C26.47,1.63,13.8,1.4,0,.76v19.9c0,6.63,0,16.2,0,22.83,30.86,0,53.16-.9,81.28-.9,4.26,0,8.65,0,13.22.07q5,.06,10.34.06c12.25,0,25.86-.21,39.47-.21,17.92,0,35.85.36,50.68,2l0-20.63c0-6.87,0-15.7,0-22.58-32.36,0-56.33-.79-80.21-.79Z"/></g></svg>
								<svg preserveAspectRatio="none" class = "fill" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195 45"><defs><style>.button-wiggle-fill{fill:#424a81;}</style></defs><title>Button Wiggle Fill</title><g id="Layer_23" data-name="Layer 23"><path class="button-wiggle-fill" d="M195,44.5c-14.83-1.64-32.76-2-50.68-2-13.61,0-27.22.2-39.47.2-3.58,0-7,0-10.34-.06-4.57,0-9-.07-13.22-.07-28.12,0-50.42.91-81.28.91,0-6.63,0-16.2,0-22.83V.76c13.8.64,26.47.86,38.89.86,19.33,0,38.07-.55,59.56-1C103.94.54,109.33.5,114.73.5c23.89,0,47.85.79,80.21.79,0,6.87,0,15.71,0,22.58Z"/></g></svg>
								<span>Website</span>
							</a>
						`
						// modal_content += `<a href = "${school.website_link}" target = "_blank"><button class = "btn btn--blue_inverse">Website</button></a>`;
					}
					modal_content += `</div>`;
				}
				// modal_content +=
						
				modal_content += `</div>`;

				modal.innerHTML = modal_content;

				//if we are on mobile, then freeze the page.
				if(window.innerWidth <= 1200) {
					disablePageScroll();
				}

				document.getElementById("map-modal-close").addEventListener('click', function(e) {
					document.getElementById('map-popover-modal').style.display = "none";
					enablePageScroll();
				})

				modal.addEventListener('click', (e) => {
					e.stopPropagation();
					if(e.target === modal) {
						modal.style.display = "none";
						enablePageScroll();
					}
				})

				function close_window() {
					console.log("Testing close!");
				}

				let infowindow_content = `
				<div id = "map-popover" class = "map-popover-holder">
					<div class = "map-popover-holder__close">
						<button id = "map-modal-close-desktop"></button>
					</div>
					<div class = "map-popover-arrow">&#9668;</div>
					<div class = "map-popover">
						<h4 class = "map-popover__title">${school.name}</h4>
						<p class = "map-popover__location grey">${school.address}</p>
						<p class = "map-popover__urn grey">URN: <strong class = "navy">${school.urn}</strong></p>
						<p class = "map-popover__lea grey">LA: <strong>${school.LEA}</strong></p>
						<p class = "map-popover__rating grey">Rating: <strong class = "${that.calculate_text_colour(school.rating)}">${school.rating}</strong></p>
						<p class = "map-popover__pupils grey">Number of pupils: <strong class = "navy">${school.pupil_number}</strong></p>
						<p class = "map-popover__key-stages grey">Age Range: <strong>${school.age_range}</strong></p>`;

				if(validURL(school.ofsted_link) || validURL(school.website_link)) {
					infowindow_content += `<div class = "map-popover__buttons">`;
					if(validURL(school.ofsted_link)) {
						infowindow_content += `
							<a class = "btn navy" href = "${school.ofsted_link}" target = "_blank">
								<svg preserveAspectRatio="none" class = "empty" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195 45"><defs><style>.button-wiggle{fill:#424a81;}</style></defs><title>Button Wiggle</title><g id="Layer_23" data-name="Layer 23"><path class="button-wiggle" d="M114.73,2.5c11,0,22.16.17,34,.35,13.63.21,27.7.42,44.25.44v11.6l0,9,0,18.4c-15.64-1.56-34.12-1.77-48.68-1.77-7,0-14,.06-20.79.11-6.55.05-12.73.1-18.68.1-3.86,0-7.23,0-10.32-.06-4.42,0-8.75-.07-13.24-.07-13.75,0-25.89.21-38.75.43-12.6.23-25.61.45-40.53.47V2.85c12.09.53,23.87.78,36.89.78,14.62,0,29-.32,44.27-.66,5-.11,10.07-.23,15.33-.33S109,2.5,114.73,2.5h0m0-2c-5.4,0-10.79,0-16.28.14-21.49.43-40.23,1-59.56,1C26.47,1.63,13.8,1.4,0,.76v19.9c0,6.63,0,16.2,0,22.83,30.86,0,53.16-.9,81.28-.9,4.26,0,8.65,0,13.22.07q5,.06,10.34.06c12.25,0,25.86-.21,39.47-.21,17.92,0,35.85.36,50.68,2l0-20.63c0-6.87,0-15.7,0-22.58-32.36,0-56.33-.79-80.21-.79Z"/></g></svg>
								<svg preserveAspectRatio="none" class = "fill" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195 45"><defs><style>.button-wiggle-fill{fill:#424a81;}</style></defs><title>Button Wiggle Fill</title><g id="Layer_23" data-name="Layer 23"><path class="button-wiggle-fill" d="M195,44.5c-14.83-1.64-32.76-2-50.68-2-13.61,0-27.22.2-39.47.2-3.58,0-7,0-10.34-.06-4.57,0-9-.07-13.22-.07-28.12,0-50.42.91-81.28.91,0-6.63,0-16.2,0-22.83V.76c13.8.64,26.47.86,38.89.86,19.33,0,38.07-.55,59.56-1C103.94.54,109.33.5,114.73.5c23.89,0,47.85.79,80.21.79,0,6.87,0,15.71,0,22.58Z"/></g></svg>
								<span>Ofsted report</span>
							</a>
						`
						// infowindow_content += `<a href = "${school.ofsted_link}" target = "_blank"><button class = "btn btn--blue_inverse">Ofsted Report</button></a>`;
					}

					if(validURL(school.website_link)) {
						infowindow_content += `
							<a class = "btn navy" href = "${school.website_link}" target = "_blank">
								<svg preserveAspectRatio="none" class = "empty" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195 45"><defs><style>.button-wiggle{fill:#424a81;}</style></defs><title>Button Wiggle</title><g id="Layer_23" data-name="Layer 23"><path class="button-wiggle" d="M114.73,2.5c11,0,22.16.17,34,.35,13.63.21,27.7.42,44.25.44v11.6l0,9,0,18.4c-15.64-1.56-34.12-1.77-48.68-1.77-7,0-14,.06-20.79.11-6.55.05-12.73.1-18.68.1-3.86,0-7.23,0-10.32-.06-4.42,0-8.75-.07-13.24-.07-13.75,0-25.89.21-38.75.43-12.6.23-25.61.45-40.53.47V2.85c12.09.53,23.87.78,36.89.78,14.62,0,29-.32,44.27-.66,5-.11,10.07-.23,15.33-.33S109,2.5,114.73,2.5h0m0-2c-5.4,0-10.79,0-16.28.14-21.49.43-40.23,1-59.56,1C26.47,1.63,13.8,1.4,0,.76v19.9c0,6.63,0,16.2,0,22.83,30.86,0,53.16-.9,81.28-.9,4.26,0,8.65,0,13.22.07q5,.06,10.34.06c12.25,0,25.86-.21,39.47-.21,17.92,0,35.85.36,50.68,2l0-20.63c0-6.87,0-15.7,0-22.58-32.36,0-56.33-.79-80.21-.79Z"/></g></svg>
								<svg preserveAspectRatio="none" class = "fill" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195 45"><defs><style>.button-wiggle-fill{fill:#424a81;}</style></defs><title>Button Wiggle Fill</title><g id="Layer_23" data-name="Layer 23"><path class="button-wiggle-fill" d="M195,44.5c-14.83-1.64-32.76-2-50.68-2-13.61,0-27.22.2-39.47.2-3.58,0-7,0-10.34-.06-4.57,0-9-.07-13.22-.07-28.12,0-50.42.91-81.28.91,0-6.63,0-16.2,0-22.83V.76c13.8.64,26.47.86,38.89.86,19.33,0,38.07-.55,59.56-1C103.94.54,109.33.5,114.73.5c23.89,0,47.85.79,80.21.79,0,6.87,0,15.71,0,22.58Z"/></g></svg>
								<span>Website</span>
							</a>
						`
						// infowindow_content += `<a href = "${school.website_link}" target = "_blank"><button class = "btn btn--blue_inverse">Website</button></a>`;
					}

					infowindow_content += `</div>`;
				}

				infowindow_content += `
					</div>
				</div>
				`;

				that.infowindow.setContent(infowindow_content);

				// console.log("Parent: ", $('#map-popover').parent().parent().parent().parent());
				//<p>${location['tel']}</p>
				//<p>${location['contact']}</p>

				marker.getDraggable = function() { return false }

				// DOMTokenList.prototype.remove.apply(this.mapEle.classList, Object.values(this.colours).map(color => 'map--' + color));
				that.mapEle.classList.add('map--');

				if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 1200) {
					// some code..
				} else {
					// that.infowindow.open(that.map, marker);
					// that.addInfoWindow(marker, infowindow_content);
					var infoWindow = new google.maps.InfoWindow({
						content: infowindow_content,
						// pixelOffset: new mapsApi.Size(-280, 66),
					});

					google.maps.event.addListener(infoWindow, 'domready', () => {
						console.log("Info Window has been opened")
						document.getElementById("map-modal-close-desktop").addEventListener('click', function(e) {
							that.displayed_infowinow.close();
							that.openedMarker = undefined;
						})
					})

					infoWindow.open(that.map, marker);

					that.displayed_infowinow = infoWindow;
					// that.infowindow = infoWindow;
				}

				// that.map.pan
				let key = document.querySelector('.key.open');
				let key_closed = key.classList.contains('hidden')

				that.map.panTo(marker.getPosition());
				//if key is not open and we're not on mobile add an offset
				if(window.innerWidth > 1400 && !key_closed) {
					that.map.panBy(that.map.getDiv().offsetWidth / -16, 0);
				} else if(window.innerWidth < 1400 && window.innerWidth > 1000 && !key_closed) {
					that.map.panBy(that.map.getDiv().offsetWidth / -18, 0);
				}
			} else {
				that.displayed_infowinow.close();
				that.openedMarker = undefined;
			}
		})
		return marker;
	}

	addInfoWindow(marker, content) {
		var infoWindow = new google.maps.InfoWindow({
			content: content,
			// pixelOffset: new mapsApi.Size(-280, 66),
		});
	
		google.maps.event.addListener(marker, 'click', () => {
			infoWindow.open(this.map, marker);
		});

		this.infowindow = this.infowindow;
	}


	calculate_text_colour(rating) {
		if(rating === "Outstanding") {
			return "green";
		} else if(rating === "Good") {
			return "yellow"
		} else if(rating === "Requires Improvement") {
			return "orange"
		} else if(rating === "Inadequate"){
			return "pink";
		} else {
			return "grey"
		}
	}

	calculate_image(rating) {

		let rating_file = rating.toLowerCase();
		rating_file = rating_file.replace(' ', "_");

		if(rating_file === 'outstanding') {
			return "outstanding.png";
		} else if(rating_file === 'good') {
			return "good.png";
		} else if(rating_file === 'requires_improvement') {
			return "requires_improvement.png";
		} else if(rating_file === 'inadequate') {
			return "inadequate.png";
		} else {
			return "null.png";
		}
		// if(rating) {
			
		// 	return rating_file;
		// }

		// return '';
	}

	ofsted_dropdown(rating) {
		console.log("Ofsted changed to " + rating);
		// Object.keys(this.markersJSON).forEach((key, index) => {
		// 	this.clustersArr[key].clearMarkers();
		// });
		// this.createClusters(rating);
		// this.redraw_elements();
		// this.rating()
		// this.dropdown_selected(rating);

		Object.keys(this.charts).forEach((key, index) => {
			// let region_id = key.split(' ').join('_') + "_chart";
			// let region_element = document.getElementById(region_id);
			// if(region_element) {
			// 	let region_holder = region_element.parentElement
			// 	console.log("Key: " + key);
			// 	// region_element.getElementById('')
			// 	if(visible === true) {
			// 		region_holder.classList.remove('htmlMarker--invisible');
			// 	} else {
			// 		region_holder.classList.add('htmlMarker--invisible');
			// 	}
			// }
			// console.log(this.charts[key].data.series);

			let original_data = this.charts[key].original_data;
			let new_data = [];
			let pupil_count = 0;
			if(rating !== "All") {
				original_data.forEach(data => {
					if(data.name === rating) {
						new_data.push(data);
						pupil_count = data.value;
					}				
				});

				//updating the text.
				this.charts[key].container.nextElementSibling.innerHTML = "<h4>" + pupil_count + "</h4>"
				
				// console.log(this.charts[key]);
				// console.log("Old data: ", original_data);
				// console.log("New data: ", new_data);
				this.charts[key].update({series: new_data});
			} else {
				original_data.forEach(data => {
					pupil_count += data.value;
				});

				this.charts[key].container.nextElementSibling.innerHTML = "<h4>" + pupil_count + "</h4>"

				this.charts[key].update({series: original_data});
			}
		})


		//zoom
		if(window.outerWidth <= 1000) {
			this.map.setZoom(6)
		} else {
			this.map.setZoom(7);
		}


		if(rating === "All") {
			this.selected_result = undefined;
		} else {
			this.selected_result = rating;
		}
	}

	dropdown_selected(rating) {
		Object.keys(this.la_markers).forEach((key, index) => {
			console.log(this.la_markers[key]);
			let rating_count = 0;

			let la = this.la_markers[key];
			// let la_cluster = la.cluster;
			let children = la.children;

			let la_element = document.getElementById(key + "_chart");

			children.forEach(school => {
				let icon = school.icon.url;
				console.log(icon);

				if(icon.includes(rating.toLowerCase().replace(" ", "_"))) {
					rating_count++;
					school.setVisible(true);
				} else {
					school.setVisible(false);
				}
			});

			if(la_element) {
				let la_holder = la_element.parentElement;

				if(rating_count > 0) {
					la_holder.classList.remove("htmlMarker--invisible");
				} else {
					la_holder.classList.add("htmlMarker--invisible");
				}
			}
		})
	}

	initTabs(){
		this.tabs.querySelectorAll('button').forEach(el => {
			el.addEventListener('click', ev => {
				ev.preventDefault();

				let liEle = ev.target.parentNode,
					index = [...liEle.parentNode.children].indexOf(liEle);

				if(ev.target.classList.contains('tab--active')){
					this.removeMarkers(index);
				} else {
					this.addMarkers(index);
				}

				ev.target.classList.toggle('tab--active');
			});
		});
	}

	addMarkers(index){
		this.clustersArr[index].addMarkers(this.markersArr[index]);
		this.clustersArr[index].repaint();
	}

	removeMarkers(index){
		this.clustersArr[index].removeMarkers(this.markersArr[index]);
		this.clustersArr[index].repaint();
	}
}
